import React from "react";

import { Link } from "react-router-dom";

import { PALETTE } from "../../common/ThemeConstants";
import { Col, Row } from "react-bootstrap";
import { useSmartName } from "../../api/useSmartName";
import { getEquipmentIcon } from "../../common/Utilities";

export default function CardPlan({
  title = "",
  height,
  weeks,
  level,
  color = PALETTE.LIGHTGRAY,
  backgroundColor = PALETTE.LIGHTGRAY,
  cover = "Undefined",
  expire_at,
  price,
  to = "",
  equipments = [],
  isActive = true,
}) {
  const weeksText = weeks == 1 ? "settimana" : "settimane"
  const cardBackgroundColor = backgroundColor;
  const parseName = useSmartName();
  const opacity = isActive ? 1 : 0.7

  return (
    <div
      style={{
        color: color,
        backgroundColor: cardBackgroundColor,
        border: "unset",
        margin: 0,
        border: !isActive && "1px solid " + PALETTE.VERYKINDALIGHTGRAY
      }}
      className={`text-center m-auto workout-card rounded-md ${isActive && "shadow-sm"}`}
    >
      <Link
        to={to}
        className="text-centers"
        style={{ textDecoration: "none", color: color, display: "inline-flex", width: "100%", height: height }}
      >
        <div
          className="rounded-md align-self-center text-center"
          style={{
            backgroundImage: `url(${cover})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            aspectRatio: 1,
            height: height,
            width: height,
            border: `6px solid ${PALETTE.WHITE}`,
            opacity: opacity
          }}
        >
          {/* {!isActive && (

            <div style={{ width: "100%", height: "100%", background: PALETTE.LIGHTGRAYTRANSPARENT }}>
              <div
                className="text-center align-items-center m-auto align-self-center"
                style={{ height: "100%", width: "100%", background: PALETTE.CIRCLETRANSPARENTGRADIENTLIGHT, display: "flex" }}>
                <img
                  src={IconLockActive}
                  className="m-auto"
                  style={{
                    marginBottom: 6,
                    marginLeft: 10,
                    marginRight: 4,
                    width: 30,
                    height: 30
                  }} />
              </div>
            </div>
          )} */}
        </div>
        <Row style={{ width: "100%", margin: 0 }}>
          <Col
            xs={8}
            className="py-2 text-start"
            style={{
              opacity: opacity,
              paddingLeft: 8,
              paddingRight: 0,
              overflowY: "auto",
              height: height
            }}
          >
            <p className="mb-1" style={{ fontWeight: "bold", fontSize: 16 }}>{parseName(title, 20, 20)}</p>
            <span
              className="rounded-md py-1 px-2 me-1 mb-1"
              style={{
                fontSize: 10,
                color: PALETTE.GRAY,
                backgroundColor: PALETTE.LIGHTGRAY,
                display: "inline-block",
                marginTop: 2
              }}
            >{`${weeks} ${weeksText}`}</span>
            <span
              className={`rounded-md mb-1 py-1 px-2 ${equipments.length > 0 ? "me-1" : ""}`}
              style={{
                fontSize: 10,
                color: PALETTE.GRAY,
                backgroundColor: PALETTE.LIGHTGRAY,
                display: "inline-block",
                marginTop: 2
              }}
            >{`Lv. ${level}`}</span>
            {equipments.length > 0 && equipments.map((equipment, index) => (
              <span
                key={index}
                className="rounded-md mb-1 py-1 px-2 me-1 align-self-center"
                style={{
                  fontSize: 10,
                  color: PALETTE.GRAY,
                  backgroundColor: PALETTE.LIGHTGRAY,
                  display: "inline-block",
                  marginTop: 2
                }}
              >{getEquipmentIcon(equipment.name)}{`${equipment.name}`}</span>
            )
            )}

          </Col>
          <Col xs={4} className="text-end align-self-center" style={{ paddingRight: 12, paddingLeft: 0 }}>
            {isActive ? (
              <>
                <p style={{ marginBottom: 0, fontSize: 10 }}>Valido fino: </p>
                <span style={{ fontWeight: "bold", fontSize: 12 }}>{expire_at}</span>
              </>
            ) : (
              <span
                className="px-2 py-1"
                style={{
                  color: PALETTE.DARK,
                  background: PALETTE.WHITE,
                  fontWeight: "bold",
                  fontSize: 16,
                  opacity: 1
                }}>{price}€</span>
            )}
          </Col>
        </Row>
      </Link >
    </div >
  );
}
